import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {StorageService} from '../../../../services/storage/storage.service';
import {TranslateService} from '@ngx-translate/core';
import {CommonService} from '../../../../services/apiServices/business/common.service';

declare let navigator: any;
declare let window: any;

@Component({
  selector: 'app-mailing-model-editor',
  templateUrl: './mailing-model-editor.component.html',
  styleUrls: ['./mailing-model-editor.component.scss']
})
export class MailingModelEditorComponent implements OnInit {
  @ViewChild('inlineFrame', { static: false }) iframe: ElementRef;
  @Input() loolLink;
  @Input() draggableColumns;
  @Output() public closeDialogue: EventEmitter<boolean>;
  fieldMap: any;
  loolFileUrl: string;

  constructor(private storageService: StorageService, private commonService: CommonService, public translate: TranslateService) {
    this.closeDialogue = new EventEmitter<boolean>();
    if (window.addEventListener) {
      window.addEventListener('message', this.iFrameMessageHandler.bind(this), false);
    } else {
      (<any>window).attachEvent('onmessage', this.iFrameMessageHandler.bind(this));
    }
  }

  ngOnInit() {
    this.fieldMap = {};
    for (const a of this.draggableColumns) {
      this.fieldMap['column-' + this.draggableColumns.indexOf(a)] = ' ${' + a + '} ';
    }
    // window.addEventListener('message', this.iFrameMessageHandler.bind(this), false);
    if (this.loolLink) {
      this.loolFileUrl  = this.loolLink + '?ui_defaults=UIMode=tabbed;TextSidebar=false&access_token=' + this.storageService.getTokenFromStorage();
    }
  }
  copyText(idx: number) {
    const dataValue = this.fieldMap['column-' + idx];
    this.writeTextToClipBoard(dataValue);
  }
  writeTextToClipBoard(text) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text)
        .then(() => {
        })
        .catch(err => {
          // This can happen if the user denies clipboard permissions:
        });
    }
    else if (window.clipboardData) {
      window.clipboardData.setData('Text', text);
    }
    else {
      const textArea = document.createElement('textarea');
      textArea.value = text;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
      } catch (err) {
      }

      document.body.removeChild(textArea);
    }
  }
  post(msg) {
    let nativeEl =  this.iframe.nativeElement;
    nativeEl = nativeEl.contentWindow || (nativeEl.contentDocument.document || nativeEl.contentDocument);
    nativeEl.postMessage(JSON.stringify(msg), '*');

  }
  documentSave() {
    this.post({
      'MessageId' : 'Action_Save',
      'Values' : {
        'DontTerminateEdit' : false,
        'DontSaveIfUnmodified': false,
        'Notify' : true
      }
    });
  }
  iFrameMessageHandler: any = (event: any) => {
    // Receive message from Iframe
    let msg = null;
    try {
      msg = JSON.parse(event.data);
    } catch (e) {
      // ignore it
    }
    if (!msg) {
      return;
    }
    // App_LoadingStatus --> Value = Document_Loaded --> Document Ready --> Can send Posts
    if (msg.MessageId === 'App_LoadingStatus') {
      if (msg.Values) {
        if (msg.Values.Status === 'Document_Loaded') {
          const isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
            input !== null && input.tagName === 'IFRAME';

          const inlineFrame = document.getElementById('inlineFrame');
          if (isIFrame(inlineFrame) && inlineFrame.contentWindow) {
            inlineFrame.contentWindow.postMessage(JSON.stringify({ 'MessageId': 'Host_PostmessageReady' }), '*');
            inlineFrame.contentWindow.postMessage(JSON.stringify({ 'MessageId': 'Hide_Menubar' }), '*');
            inlineFrame.contentWindow.postMessage(JSON.stringify({ 'MessageId': 'Remove_Button', 'Values': {'id': 'styles'} }), '*');
          }
        }
      }
    }
    else if (msg.MessageId === 'Action_Save_Resp' && msg.Values && msg.Values.success) {
      this.commonService.addToast({life: 3000, severity: 'info', summary: '', detail: this.translate.instant('UPLOAD_COMPONENT.DOC_SAVED')});
/*      this.post({
        'MessageId': 'Action_Close',
        'Values': {
          'Notify' : true
        }});*/
      setTimeout(() => {
        if (window.addEventListener) {
          window.removeEventListener('message', this.iFrameMessageHandler.bind(this), false);
        } else {
          (<any>window).detachEvent ('onmessage', this.iFrameMessageHandler.bind(this));
        }
        this.closeDialogue.emit(true);
      }, 500);
    }
  }
/*  documentClose() {
    this.post({
      'MessageId': 'Action_Close',
      'Values': {
        'Notify' : true
      }});
    setTimeout(() => {
      this.closeDialogue.emit(true);
    }, 500);
  }*/
}
